/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramUsersControllerPatchLanguageMutationRequest,
  TelegramUsersControllerPatchLanguageMutationResponse,
  TelegramUsersControllerPatchLanguage401,
} from '../../types/TelegramUsersControllerPatchLanguage.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramUsersPatchLanguage } from '../../methods/telegramUsersPatchLanguage.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramUsersPatchLanguageMutationKey = () => [{ url: '/api/telegram/users/language' }] as const;

export type TelegramUsersPatchLanguageMutationKey = ReturnType<typeof telegramUsersPatchLanguageMutationKey>;

/**
 * {@link /api/telegram/users/language}
 */
export function useTelegramUsersPatchLanguage<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramUsersControllerPatchLanguageMutationResponse,
      ResponseErrorConfig<TelegramUsersControllerPatchLanguage401>,
      { data: TelegramUsersControllerPatchLanguageMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<TelegramUsersControllerPatchLanguageMutationRequest>> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramUsersPatchLanguageMutationKey();

  return useMutation<
    TelegramUsersControllerPatchLanguageMutationResponse,
    ResponseErrorConfig<TelegramUsersControllerPatchLanguage401>,
    { data: TelegramUsersControllerPatchLanguageMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return telegramUsersPatchLanguage(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
